<template>
    <div class="h-100 d-flex justify-content-center align-items-center" v-if="loadingDashboard">
        <vue-loaders-ball-beat scale="2" color="black" />
    </div>
    <div v-else>
        <div style="clear:both; border-bottom:solid 1px #ccc; margin-top:1rem;">
            <a v-on:click="changeTab('a')">
                <button class="newTab" id="dashTab-selected">NEW SUBMISSIONS</button>
            </a>
            <a v-on:click="changeTab('e')">
                <button class="erpTab" id="dashTab">ENTERED INTO ERP</button>
            </a>
            <a v-on:click="changeTab('d')">
                <button class="deniedTab" id="dashTab">DENIED</button>
            </a>
        </div>
        <br>
        <priceworkflow-dashboard-pagination
            :totalSubmissions="totalSubmissions"
            :previousPageLink="previousPageLink"
            :nextPageLink="nextPageLink"
            :currPage="currPage"
            :totalPages="totalPages"
            @change-page="changePage"
        ></priceworkflow-dashboard-pagination>
        <br>
        <table class="submissionTBL">
            <tr class="TBLhead">
                <th v-if="bulkActionsAvailable" style="width:5%;">BULK SELECT</th>
                <th style="width:8%;">{{ submittedColHeader }}</th>
                <th style="width:5%;">SUBMITTED BY</th>
                <th style="width:12%;">PROMOTION</th>
                <th style="width:12%;">PROMO DETAIL</th>
                <th style="width:12%;">BT</th>
                <th style="width:8%;">COMPANY</th>
                <th style="width:8%;">LEVEL</th>
                <th style="width:7%;">BASIS</th>
                <th style="width:7%;">ORDER #</th>
                <th style="width:8%;">VOLUME</th>
                <th colspan="3" style="text-align:center;width:10%;">ACTIONS</th>
            </tr>
            <tr v-for="entry in submissions">
                <td v-if="bulkActionsAvailable">
                    <!-- {{ entry.id }} -->
                    <input type="checkbox" class="submissionId" :value="entry.id" v-model="selectedIds" />
                </td>
                <td>{{ entry.timestamp }}</td>
                <td>{{ entry.requested_by_user.full_name }}</td>
                <td>{{ entry.promoString }} ({{ entry.promo_year }})</td>
                <td>{{ entry.promo_detail }}</td>
                <td>{{ entry.cust_id }}</td>
                <td>{{ entry.company }}</td>
                <td>{{ entry.price_level }}</td>
                <td>{{ entry.price_basis }}</td>
                <td>
                    <ul style="list-style-type:none;">
                        <li v-for="ordNum in entry.ord_num">
                            {{ ordNum }}
                        </li>
                    </ul>
                </td>
                <td>{{ entry.initial_volume }}</td>
                <td id="iconTd">
                    <router-link :to="{ name: 'PriceWorkflowViewPromo', params: {ppId: entry.id}}">
                        <img id="iconImg" src="/images/icon-circle-view-green.png" />
                    </router-link>
                    <p id="iconLabel">VIEW</p>
                </td> 
                <td v-if="tabStatus == 'a'" id="iconTd">
                    <a v-on:click="submitErp(entry.id)">
                        <img id="iconImg" src="/images/icon-circle-add-orange.png" />
                    </a>
                    <p id="iconLabel">ERP</p>
                </td>
                <td id="iconTd">
                    <a v-on:click="deleteEntryEmitter(entry.id)">
                        <img id="iconImg" src="/images/icon-circle-trash.png" />
                    </a>
                    <p id="iconLabel">DELETE</p>
                </td>
            </tr>
        </table>
        <ul v-if="bulkActionsAvailable" id="bulkActionUl">
            <li style="border-right: 1px solid black; padding-right:10px;">
                <input type="checkbox" id="checkAll" v-on:click="checkAll()" style="padding: 0 10px 0 1px; color:#999;"> SELECT ALL
            </li>
            <li>
                <span><strong>BULK ACTIONS: </strong></span>
            </li>
            <li v-if="tabStatus == 'a'">
                <button @click="getConfirmation('bulkErp', 'e');" class="btn-round-green" type="button" style="margin-top:0;">APPROVE ERP</button>
            </li>
            <li v-if="loadingBulkAction">
                <vue-loaders-ball-beat scale="1" color="black" />
            </li>
        </ul>
        <br>
        <priceworkflow-dashboard-pagination
            :totalSubmissions="totalSubmissions"
            :previousPageLink="previousPageLink"
            :nextPageLink="nextPageLink"
            :currPage="currPage"
            :totalPages="totalPages"
            @change-page="changePage"
        ></priceworkflow-dashboard-pagination>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            bulkActionsAvailable: true,
            bulkSelect: [],
            currPage: "",
            isAdmin: false,
            loadingBulkAction: false,
            loadingDashboard: true,
            nextPageLink: "",
            paginationResults: {},
            previousPageLink: "",
            selectedIds: [],
            submissions: [],
            submittedColHeader: "STARTED",
            tabStatus: "a",
            totalPages: "",
            totalSubmissions: "",
        }
    },
    created() {
        this.getPaginationResults();

        this.$parent.$on('triggerPromoDashboardRefresh', () => {
            // Reset checkboxes and selectedIds
            $('#checkAll').prop('checked', false);
            $('.submissionId').prop('checked', false);
            this.selectedIds = [];

            this.getPaginationResults();
        });
    },
    watch: {
        paginationResults() {
            this.submissions = this.paginationResults['data'];
            this.totalSubmissions = this.paginationResults['total'];
            this.currPage = this.paginationResults['current_page'];
            this.totalPages = this.paginationResults['last_page'];
            this.previousPageLink = this.paginationResults['prev_page_url'];
            this.nextPageLink = this.paginationResults['next_page_url'];

            this.loadingDashboard = false;
            this.loadingBulkAction = false;
        },
        user () {
            this.getPaginationResults();
        },
        tabStatus () {
            $("#dashTab-selected").attr("id", "dashTab");

            if (this.tabStatus == "a") {
                $(".newTab").attr("id", "dashTab-selected");
                this.submittedColHeader = "SUBMITTED";
                this.bulkActionsAvailable = true;
            } else if (this.tabStatus == "e") {
                $(".erpTab").attr("id", "dashTab-selected");
                this.submittedColHeader = "ENTERED";
                this.bulkActionsAvailable = false;
            } else if (this.tabStatus == "d") {
                $(".deniedTab").attr("id", "dashTab-selected");
                this.submittedColHeader = "SUBMITTED";
                this.bulkActionsAvailable = false;
            }
        },
        selectedIds() {
            if(this.selectedIds.length == $('.submissionId').length) {
                $("#checkAll").prop('checked', true);
            } else {
                $("#checkAll").prop('checked', false);
            }
        }
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            adminUsers: state => state.priceDeviationAdmins
        })
    },
    methods: {
        getPaginationResults() {
            axios.get(`/api/getPromoSubmissions/${this.tabStatus}/${this.user.id}/`).then(response => {
                this.paginationResults = response.data;
            });
        },
        changePage(link) {
            axios.get(link).then(response => {
                this.paginationResults = response.data;
            });
        },
        changeTab(newStatus) {
            this.tabStatus = newStatus;
            this.getPaginationResults();
        },
        submitErp(ppId) {
            let data = {
                ppId: ppId,
                userId: this.user.id
            }

            axios.post(`/api/submitPromoToErp`, data).then(response => {
                this.getPaginationResults();
            });
        },
        deleteEntryEmitter(ppId) {
            if(confirm("Did you mean to click DELETE? This will remove the selected Promo from the database.")) {
                this.$emit('delete-entry', ppId);
            }
        },
        checkAll() {
            if($("#checkAll").prop('checked') == true) {
                this.selectedIds = [];

                for(let submission of this.submissions) {
                    let checkbox = document.querySelector(`input.submissionId[value="${submission.id}"]`);

                    if(checkbox && !checkbox.disabled) {
                        this.selectedIds.push(submission.id);
                    }
                }
            } else {
                this.selectedIds = [];
            }
        },
        getConfirmation(action, status) {
            if($('[class="submissionId"]:checked').length > 0) {
                let confirmMsg = this.getConfirmMsg(action);
                let confirmVal = confirm(confirmMsg);

                if(confirmVal) {
                    this.bulkActionEmitter(action, status);
                } else {
                    return false;
                }
            } else {
                alert("No submissions were selected to take action on.");
            }
        },
        getConfirmMsg(action) {
            if(action == "bulkErp") {
                return "Are you sure you wish to bulk approve the selected items? Once confirmed the database will be updated for each entry.";
            }
        },
        bulkActionEmitter(action, status) {
            this.loadingBulkAction = true;

            this.$emit('bulk-action', {
                action: action,
                signOffStatus: status,
                submissionIds: this.selectedIds,
                userId: this.user.id
            });
        },
        findIfAdmin() {
            if(this.adminUsers.includes(this.user.id)) { // Admin
                this.isAdmin = true;
            } else { // Not Admin!
                this.isAdmin = false;
            }
        }
    },
    beforeDestroy() {
        this.$parent.$off('triggerPromoDashboardRefresh');
    }
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    .TBLhead th {
        font-weight: bold;
        border-bottom: solid 1px #333;
        margin-bottom: 0;
        vertical-align: bottom;
        text-align: left;
    }

    .submissionTBL {
        width: 100%;
        margin: 0;
        text-align: left;
        font-size: 0.9rem;
    }

    #iconImg {
        height:26px; 
        width:auto;
    }

    #iconTd {
        text-align:center; 
        width:2%;
        cursor: pointer;
    }

    #iconLabel {
        font-size:0.6rem; 
        color:#999;
    }

    #dashTab {
        position: relative;
        top: 1px;
        font-family: Arial;
        font-size: 0.8rem;
        line-height: 1.6rem;
        background: #fff;
        border: solid 1px #ccc;
        padding: 0.8rem 1rem;
        color: #999;
        cursor: pointer;
        width: 11rem;
    }

    #dashTab-selected {
        position: relative;
        top: 1px;
        font-family: Arial;
        font-size: 0.8rem;
        line-height: 1.6rem;
        border: solid 1px #ccc;
        border-left: 0px;
        padding: 0.8rem 1rem;
        cursor: pointer;
        width: 11rem;
        background-color: #cd1b00;
        background: #cd1b00;
        color: #fff;
    }

    .submissionTBL td {
        padding: 1rem .25rem 1rem 0;
        background: #fff;
        border-bottom: dotted 1px #ccc;
    }

    #bulkActionUl {
        list-style-type:none; 
        display:flex; 
        flex-wrap:wrap; 
        align-items:center; 
        margin-top:5px;
    }

    #bulkActionUl li {
        padding-left:10px;
    }
</style>